import { request, buildQuery } from '../../lib/apiClient';
export function listProjects(params) {
    const query = buildQuery({
        status: params?.status,
        customerId: params?.customerId,
        installerId: params?.installerId,
        priority: params?.priority,
        limit: params?.limit,
        nextToken: params?.nextToken,
    });
    return request(`/projects${query}`);
}
export function getProject(id) {
    return request(`/projects/${id}`);
}
export function createProject(input) {
    return request('/projects', {
        method: 'POST',
        body: JSON.stringify(input),
    });
}
export function updateProject(id, input) {
    return request(`/projects/${id}`, {
        method: 'PUT',
        body: JSON.stringify(input),
    });
}
export function assignInstaller(projectId, installerId, installerName) {
    return request(`/projects/${projectId}/assign`, {
        method: 'PATCH',
        body: JSON.stringify({ installerId, installerName }),
    });
}
export function unassignInstaller(projectId) {
    return request(`/projects/${projectId}/unassign`, {
        method: 'PATCH',
        body: JSON.stringify({}),
    });
}
export function checkIn(projectId, latitude, longitude, accuracy) {
    return request(`/projects/${projectId}/checkin`, {
        method: 'PATCH',
        body: JSON.stringify({ latitude, longitude, accuracy }),
    });
}
export function checkOut(projectId) {
    return request(`/projects/${projectId}/checkout`, {
        method: 'PATCH',
        body: JSON.stringify({}),
    });
}
export function completeProject(projectId, completionNotes) {
    return request(`/projects/${projectId}/complete`, {
        method: 'PATCH',
        body: JSON.stringify({ completionNotes }),
    });
}
export function getUploadUrl(projectId, type, filename, contentType) {
    return request(`/projects/${projectId}/photos/upload-url`, {
        method: 'POST',
        body: JSON.stringify({ type, filename, contentType }),
    });
}
export function recordPhoto(projectId, photoId, type, s3Key, uploadedBy) {
    return request(`/projects/${projectId}/photos`, {
        method: 'POST',
        body: JSON.stringify({ photoId, type, s3Key, uploadedBy }),
    });
}
export function getSketchUploadUrl(projectId) {
    return request(`/projects/${projectId}/sketch-upload-url`);
}
export function listPhotos(projectId) {
    return request(`/projects/${projectId}/photos`);
}
export function deletePhoto(projectId, photoId) {
    return request(`/projects/${projectId}/photos/${photoId}`, {
        method: 'DELETE',
    });
}
export function listInstallers(params) {
    const query = buildQuery({
        name: params?.name,
        status: params?.status,
        limit: params?.limit,
    });
    return request(`/installers${query}`);
}
//# sourceMappingURL=api.js.map